import { useState } from "react";
import { Modal, Button } from "antd";
import { formatDate } from "../../../../Components/Common/FormatDate/FormatDate";
import "../../utils/demande.css";
import { motion } from "framer-motion";
import { clotureDemande } from "../../services/demandeApi";
import toast from "react-hot-toast";

const SuiviDemande = ({ selectedDemande }) => {
    const [openModal, setOpenModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const suivis = selectedDemande?.suivis
    
    const handleOpenModal = (item) => {
        setCurrentItem(item);
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setCurrentItem(null);
        setOpenModal(false);
    };

    const confirmCloture = async () => {
        if (!currentItem) return;

        setLoading(true);
        try {
            await clotureDemande(selectedDemande?.id);
            toast.success("Demande clôturée avec succès !");
        } catch (error) {
            console.error(error);
            toast.error("Erreur lors de la clôture de la demande.");
        } finally {
            setLoading(false);
            handleCloseModal();
        }
    };

    return (
        <div className="SD-timeline-container">
            {suivis && suivis.length > 0 ? (
                suivis.map((item, index) => (
                    <motion.div
                        key={index}
                        className="SD-timeline-item"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.15 }}
                    >
                        <div
                            className={`SD-timeline-icon ${
                                item?.status === "done"
                                    ? "SD-icon-done"
                                    : "SD-icon-pending"
                            }`}
                        ></div>

                        <div className="SD-timeline-content-with-button">
                            <div className="SD-timeline-content">
                                <p className="SD-timeline-title">
                                    <strong>Demande {item?.title}</strong>
                                </p>
                                <p className="SD-timeline-date">
                                    {formatDate(item?.trackingDate, true)}
                                </p>
                                <p className="SD-timeline-date">
                                    {selectedDemande?.description || "Aucune description"}
                                </p>
                            </div>

                            {item?.status === "RECU" && (
                                <Button
                                    danger
                                    size="small"
                                    className="SD-cloture-btn"
                                    onClick={() => handleOpenModal(item)}
                                >
                                    Clôturer
                                </Button>
                            )}
                        </div>
                    </motion.div>
                ))
            ) : (
                <p>Aucun suivi disponible pour le moment.</p>
            )}

            <Modal
                title={
                    <div className="SD-modal-header-title">
                        <span className="SD-modal-warning-icon">⚠️</span>
                        Confirmation de clôture
                    </div>
                }
                open={openModal}
                onCancel={handleCloseModal}
                getContainer={false}
                zIndex={2000}
                footer={null}
                centered
                className="SD-confirm-modal"
            >
                <div className="SD-modal-body">
                    <p className="SD-modal-text">
                        Êtes-vous sûr de vouloir clôturer cette demande ?
                        <br />
                        Cette action est irréversible.
                        <br />
                        Vous ne pouvez plus d'effectuer d'acction liéé à cette demande.
                    </p>

                    <div className="SD-modal-footer">
                        <Button
                            onClick={handleCloseModal}
                            size="large"
                            className="SD-btn-cancel"
                            disabled={loading}
                        >
                            Annuler
                        </Button>

                        <Button
                            type="primary"
                            danger
                            size="large"
                            onClick={confirmCloture}
                            className="SD-btn-confirm"
                            loading={loading}
                        >
                            Oui, clôturer
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SuiviDemande;
